const navigation = [
  // { name: 'Home', href: '/' },
  // { name: 'About', href: '#about' },
  // { name: 'Contact Us', href: '/contact-us' },
  { name: 'Contact', href: '/#contact-us' },
]

export default navigation